import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import axios from 'axios';
import { stringInterpolate } from '../formatters/string';

var prefixEndpoint = function prefixEndpoint(url) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return stringInterpolate(url, options);
};

var HTTPClient = /*#__PURE__*/function () {
  function HTTPClient() {
    _classCallCheck(this, HTTPClient);

    _defineProperty(this, "config", void 0);

    _defineProperty(this, "instance", void 0);
  }

  _createClass(HTTPClient, null, [{
    key: "getInstance",
    value:
    /**
     * returns a singleton instance
     * @returns static class member instance
     */
    function getInstance() {
      if (!HTTPClient.instance) {
        HTTPClient.instance = axios.create();
      }

      return HTTPClient.instance;
    }
    /**
     * sets default axios config
     * @param {*} config axios config
     */

  }, {
    key: "setConfig",
    value: function setConfig() {
      var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (!HTTPClient.config) {
        HTTPClient.config = config;
      }
    }
    /**
     * return default config object
     * @returns static class member config
     */

  }, {
    key: "getConfig",
    value: function getConfig() {
      if (!HTTPClient.config) {
        HTTPClient.config = {};
      }

      return HTTPClient.config;
    }
    /**
     * initializes the httpclient(optional) Ex: HTTPClient.init(config)
     * @param {*} config axios config
     */

  }, {
    key: "init",
    value: function init(config) {
      HTTPClient.instance = axios.create(config);
    }
  }, {
    key: "get",
    value: function get(url) {
      var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : HTTPClient.getConfig();
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var endpoint = prefixEndpoint(url, options);
      return HTTPClient.getInstance().get(endpoint, config);
    }
  }, {
    key: "post",
    value: function post(url) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : HTTPClient.getConfig();
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var endpoint = prefixEndpoint(url, options);
      return HTTPClient.getInstance().post(endpoint, data, config);
    }
  }, {
    key: "put",
    value: function put(url) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : HTTPClient.getConfig();
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var endpoint = prefixEndpoint(url, options);
      return HTTPClient.getInstance().put(endpoint, data, config);
    }
  }, {
    key: "delete",
    value: function _delete(url) {
      var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : HTTPClient.getConfig();
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var endpoint = prefixEndpoint(url, options);
      return HTTPClient.getInstance()["delete"](endpoint, config);
    }
  }, {
    key: "upload",
    value: function upload(url) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : HTTPClient.getConfig();
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var endpoint = prefixEndpoint(url, options);
      return HTTPClient.getInstance().post(endpoint, data, config);
    }
  }]);

  return HTTPClient;
}();

export { HTTPClient as default };